/** Values carried over verbatim from the original prototype. */

export const IDLE_THRESHOLD_MS = 15000;
export const AUTOSAVE_DELAY_MS = 1200;
export const SESSION_TICK_MS = 1000;

export const DEFAULT_ASSIGNMENT_ID = "eng101_reflection_2";

export const DEFAULT_DRAFT_HTML = "<p><br></p>";

/** Draft Library keeps the ten most recent saves. */
export const MAX_DRAFT_VERSIONS = 10;
/** The process log keeps the last 200 events. */
export const MAX_EVENT_LOG = 200;

/** A single input adding this many characters is logged as major growth. */
export const MAJOR_GROWTH_CHAR_DELTA = 180;
/** Rolling window used to detect a revision burst. */
export const REVISION_WINDOW_MS = 15000;
/** Number of changes inside the window that marks one revision burst. */
export const REVISION_BURST_THRESHOLD = 6;

/** Flag thresholds. */
export const SHORT_WRITING_MIN_WORDS = 150;
export const SHORT_WRITING_MAX_ACTIVE_MINUTES = 8;
export const KEYSTROKE_RATIO_MIN_CHARS = 300;
export const KEYSTROKE_RATIO_THRESHOLD = 1.25;
export const HIGH_PASTE_RATIO = 0.51;
export const MULTIPLE_PASTE_FLAG_THRESHOLD = 3;
/**
 * Each blur event records one departure from the writing area, so the
 * focus-changes flag fires off blurEvents alone rather than the paired
 * focus+blur sum. Keep FLAG_MESSAGES.focusChanges in messages.ts ("...10
 * times") in sync with this number.
 */
export const LEAVES_FLAG_THRESHOLD = 10;

/** Number of flags that escalate the review mode. */
export const REVIEW_RECOMMENDED_FLAGS = 2;
export const SUBMISSION_PAUSE_FLAGS = 4;
